import React, { useRef, useContext, useEffect, useState } from "react";

import { TabsWrapper, TabsList, Tab } from "@livechat/design-system";
import styled from "@emotion/styled";
import { NavigationContext } from "../context/navigation";
import { navigationItem } from "../constants";
import { ReactComponent as LiveChatLogo } from "../assets/livechat-logo.svg";
import { Switch } from "@livechat/design-system";
import { transKey, notifyKey, transStatusKey, getStoreItem, setStoreItem } from "../utils/store";
import Select from 'react-select';
import { ChatContext } from '../context/chat';

const TabItem = styled(Tab)`
  margin-top: 0.5rem;
  padding: 0.5rem 1.5rem;
`;


const LogoItem = styled(TabItem)`
  margin-left: auto;
  > svg {
    height: 22px;
  }
`;
//new css
const HeaderBox = styled.div`
  height: 90px;
  color:#fff;
  font-size: 18px;
	line-height: 23px;
	letter-spacing: 0px;
  display:flex;
  align-items: center;
  background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAABaCAMAAAChZfCYAAAAHlBMVEVaq+JYquE/nd1WqeA+nts1mNtQpuBKo95Gotw7nNoUw3hjAAAFnElEQVR42u3bi3KjOgyA4Y3g2OL9X/jEDso/sRZy6YbKHmTjK+10/FXQzOz++e8ai3QUOg0dV5ASHXnkNDxIT0mS0zUGB4GkD4/rNTQIEd8j3TzSdBk2AImfJHrjyNcyDQ4CSWwPYhochAjukdcrDQ9ChH6dQzI8CLGE9HAxPgixBPYgRgbxJPE90jQoSGASPMYXASQ6CR5e5M9wAUhYkkSMLAJIYBI8xhcBJDZJTvtxGQ8kMAke44sAEpXEe0yl7omMD0LEyw9ExgMJmibZp8dUSxMDcSRAApHgMVGMpOI0ZRiPKQMSjkQT4VJkzBy5ZEDCmSiJQIasFtOgOZIBiUeSXBjJNOoHxARIPBOfBXsZgkjXHoCEI0npzQxBpF8PQMKZ5PRehtTF3j0AiWOCx06KbO70/QcvIOFINH0YXXsAEs4kfRpTvx9AHEggk2wPIV+f7aSO8wOQYCZ5Nwee7fSbH4DEMtH0s+jWA5BYJtup8OLOpTuPb4AQPzTJ6cdx6dMDkEgm+gFA1/9ea8rfBcHkM5REjC+ChwcJkig5jS6y7wFIjETRRIwsgseRIKC8+Z9AKK5urbsv60IkOQ4VQAKgaDnKx8iuZeraEky681AVASQCynqcVktTO1oActtaZbsnD5WiAUgIFEOo1WuwcevZahltsxcPXTEAiYFiR2y1lWGH/q9bHbxIJofxOyCgeBVOsj11xk7IbWFSRaIGGAQgMVDs+AFgwIxVcsMVNmJyJDCigHiVnHMq1QoDZo/bjHxhI6IHGOFAUHnxqBu2jU2mKQXDSHAEBCFENedHDOupbFtlg6W2CWRRfkyRLkB0jVyCQ/Ykts9CS0KzXiEs8hrSB4ioSi1zVVE7S86XA7Zl0Boh5xTBItWq0gmICmUuKgUm89vOoa9B+tC0CQTZb1Ekflo8goPwWVFnUZrqUvOleXglh9ACwcGNR0LwhGryWaQXELHkuHXVRAuRjW8wPpqccXsMj8qJ7Z9SpRuQRZrcMI1bZ1vA+AfUIwFLpM70xdJKuJ8Ljy5AyrHXa15FionUTmpYN4uUNWTeiS88m4B4GiIdgczX0FKVXne6WfkKfd3mn6WDMWh+NVR6Alnq4dpVOyYlXAceMsVmk4cXSXq7gmAKSHzmER8EDpOBQ9tOyBBgiDqFiHgtR+6RSymhGwZqzasc8UF4Ysl6MVwneluiK2EkSDjEjdC9cyvFhi8mATd7NLVLOgTRtcp9KLcZOkKntbcVtZFyn00ZG5k+P+Anu1xZd3xIj95AlrkEZ0rwGBPzUuNggdUyoNot2mRR3irWMdm4697v3GBT6RJECwcZoetVJx5KWHAZIazJehmczXU/NbT0TNw2i7qVTDy+RDoE4TT5fWZWLplLZ1J29DbgnnUqtVFSrH1wbf3ug6E2ZpclUmnnG9U96RPk+NCN1GAGjF00vPpdAtHCMQCIzBvx2a3i79OHyLQssc6UTToWm1Y6BVnc4TJ5z0HYePo9y6FR6swv2ZCLFeZuDY6OQY4PJQBQZcjIpmzT1rAJ98gJ8r5IvhcMsGAGFi4AlMLEOE6Qt2IpdXEMDzLMPA8mVNZEOgc5vszrpW3k3alf9DvV48yQdxPEGv6M2vybKzdXs9zeLjIAyHJwqc3acvAccvPiINhihk7lOEE+LTZ4+qTKXDQeBY/zHfJRucPojwOOATOkVnq/4u5+dcXvWKocwBEfhHAnuV+ofnVnYf/OABxxQPYkGOwbPS37yz8VERkJpDw1ltJQraf6id9n9vrXW7cE4AgDEiM+TJJ5lhPkayJUN9xqRE6QKEkCx78EOUV8ltRLGfrGOE6Qo5JkldENjrm+O06QI0SMwjA2QuRLIKeITxLe2rehe5PPs5wgB5NUDPfc4t3xNZBT5C9hGOQEJIvICfK7H0rMg1f59+J/GgILhG3hZhQAAAAASUVORK5CYII=') no-repeat top right #3598db;
`;
const UserInfo = styled.div`
  box-sizing: border-box;
  padding:14px 40px 12px 12px;
  position: relative;
  height:90px;  
  display:flex;
  align-items: center;
  `;
const UserImg = styled.div`
  width:64px; height:64px;border-radius: 100%; background: #d9d9d9; overflow:hidden;
  > img{ width:64px; height:64px;}
  `;
const UserName = styled.div`
	font-size: 18px;
	font-weight: bold;
	font-stretch: normal;
	line-height: 23px;
	letter-spacing: 0px;
	color: #ffffff;
  align-items: start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding:0 30px 0 15px ;
  > p{
    margin-block-start: 0;
    margin-block-end: 0;
  }
  > .userAdmin {
    color:#15537d;
    font-size: 16px;
    line-height:23px;
    margin-block-start: 0;
    margin-block-end: 0;
  }
  
  `;
const UserActive = styled.div`
 display:flex;  height:34px; border-radius: 100%;
  > .userOnline{
    display:block; width:34px; height:34px; margin-left:8px; background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmfvwAAAAvVBMVEVMaXEhxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl0hxl3///8nyGH3/fli14zt+/LP89wjx1943Z1O0n6J4alm2I9X1ISn6b+w68aV5LK57cxu2pVEz3bm+e38//05zW80y2uO4q3b9uXW9eEsyWW+79Dh9+mr6cFAznRH0Hmr6sLq+vBd1omD4KXy/PWe5rjv+/TE8NQUfmvuAAAAF3RSTlMAzgQt8/zTWAEnOVL5jcQdHmZkw4vFPS9zVL8AAAGQSURBVHjahZRpe4IwDMdBFMQD3dzWcAkoIId43277/h9rQApUdA//Fzxp+yNp0rTco1pjQRi3uH/VG/IDkmrAD3uv1ruSSBiJUrdOyBNS00R+JPpt8qR2nyXeO+SFOm+MDySeJZX7KKOouu/tPMcuY8k0F6UAHANQhylBKZiXRIdLE2DtBzPLNcN0OHenZSiREhHsdTSzNfseqVl98prSKCaYCSkVGkaYG1mdP3DOgT0S1OWd7nmYIjw6MUCviGSvzanJp2eLNdFhUxHbTVzygxY3QssHP/PvJhlhxkGakXfKV0acgMgCZun3pK0Tov6Clc8E+YpQILscIXNtvVzALTPPYCFSBPLSCWQ08OlPOgYqtuuAi6y+uWH5DAhxu0XSNhgqYXWFCJOuSrcB5wExYVWWrkcDgGYzxAouWzwA5hi/4WfOELR4ItsMUw/iwzG3ribEVtl3bEutYoD1wl0YABd6AJ/dWmMezxpkipxt1Zj19lbtwJqFbHs3X5Lmq8ZKVuqEIjdf+4bH44sFmp+gPzBuUwzmQuZDAAAAAElFTkSuQmCC') no-repeat 0 0;
  }

  > .userUnline{
    display:block; width:34px; height:34px; margin-left:8px; background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmfvwAAAAt1BMVEVMaXGoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAqoIAr////w2davMh747evSi4CqJhH+/Pzt0MvfraXCYlPdqJ/kubLKeGqpIw3BYFDszci2QzDHcGLmvri1Py28U0L89/b25+TEZ1jVk4nAXEzu1NDXl42sKxbRiHvita3z4d66TDroxb/68fCyOCWxNyPZnpRxEN3gAAAAFnRSTlMALdNS/B3O8yfEOfkDV1mMZY0E1Dg9/YNaPgAAAYpJREFUeNqFlOeWgjAQhQEVuyi7y0WKNMUG9rbl/Z9rJRMQRA/3D2HyncxkchOhqF5DFBs94a06itzV7urKSucl0Je0nKR+CWi1tSe1W0Wi1tRKatbyxLCuvVB9mFuDiLL6WR1ZFss9OEvHvGa50nraKXAyQNrP0pqJGPDf3wmgbxebwDMAb0rBAUN4P35iXFy+nBnBJ0ZKiE8ensCYjGk8Dm/f2NI46bNCwxMue+hjRugId7Y9Z3Hljsi0iAF3rDOGPh4cNiELgko9caHzSQ6uEFnsTFWhQXkO99zE6DydjjWbaQgiIT42vIyEoMiCfcUUWcJ9QhwEhFAiChQTLTGjRGm5JrxiuVMDcyo33fQVhlXY9A4xbfrRuj3MMNc6bQKTxUeJqQmZIbqF2QGcTRhHOoDcMf7hmxpBpdlUrJQ3w/QM21ux0S6EHXAzFC1l2oDue74BxC631LMxV06ERLF5TI1Ztre1XgSb+cPe1Zek+qpVX9iKa/8xeP14jNLHY/QlvJWaPEFqMfYP6blO+Y+FL0oAAAAASUVORK5CYII=') no-repeat 0 0;
  }
  `;
const UserInfoLine = styled.div`
  position: absolute;
  top:1px;
  right:0;
  height:88px;
  width:1px;
  background-image: linear-gradient(0deg, 
		#5fb1e8 0%, 
		#3598db 100%,
    #5fb1e8 0%);
  `;

const HeaderControl = styled.div`
  display:flex; align-items: center;
  > .Hswitch{

  }
  `;

const ControlItem = styled.div`
  display:flex; align-items: center; padding:0 50px 0 30px;
  > .voice{ display:block; width:26px; height:32px; margin-right:20px; background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAgCAMAAAA7dZg3AAAAjVBMVEVMaXHD5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f0YiiAFAAAALnRSTlMAZPH2rt36G7JDkjgDXtbJ5I2cRyv+u7ehpjyCqk0fFA0IbcAwll3r0YZRKU55ct/NsgAAAQxJREFUeNqd0MtygkAQheEjDMMAglzkjoKiURNz3v/xUiBUxHGTfJteTHX1X4NfWyVl5uEN2+RgC53LtM9SCmhWJkfyiKWvDUnTCgySweKeJ0mxa4E2KUkmTwWS5icmzuW5pWd6AmZ7gxYmCfmBJw7p40HxioWMG4w6kyss7Ej7kad9gT1H3sk9Fg4X+nOFjSVrOuH85Wn9v61w+oNKLzR4x+BGo9O23HEajPCipjwA8PUKtCmPAAIqaBpaY4QHjUdWUOzxRk6BkIHI81wpJRrRlGVZxEV8dnuGqPnekO1HrutGVxp1HMfngsyKRgj1jdmJshpmRBOverI+OYo84lUXcHSGbn0LyY0PzH4AGiojAw55T40AAAAASUVORK5CYII=') no-repeat 0 0;}
  > .robot{display:block; width:35px; height:32px; margin-right:20px; background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAgCAMAAACvkzHFAAAAeFBMVEVMaXHD5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f30lSbcAAAAJ3RSTlMAIFQ6Wb5rn4P0X4414xKWKBzADUzyttlp+aOHeFzRCANlgTDrQ6ZEJUe7AAAA/UlEQVR42o3T6Y6DIBSG4VO0tYpbXWsXq92++7/DYchooOjpvH+U5AmGQyS7tAdwIrYMv/msaYGvGxXaXFjjQZWkxCY6JAfiK2s09KUbazae6uF36L1YvcXuF6umg134zm0yYqGnhXIARRaYZT3QD4aRgKSPhi3wMtZbdO7chD3wAvVhyZxJdxV6n3DjGB/Yq0dUEfBizRVQ5sgaqU00m3K+kWE2e9tckybVxGv7fMWEwO5vFAhWjESSaxMB1YohbxpS/CDbjP84l2DNRZksu7GmDM7TfYXMfc0mdUwF3I1lAIyOCQDx8evJaGd0jE7AsyQjiaUEWd1rR7QT+QGQQCq2QKZcvwAAAABJRU5ErkJggg==') no-repeat 0 0;}
  > .fanyi{display:block; width:32px; height:32px; margin-right:20px; background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAilBMVEVMaXHD5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f3D5f1rTU+OAAAALXRSTlMA76ar5/TV6Q7jOvv5CQNueWNoBf2YELvC0LFB2pGDvxUZJeHIjH5ZTqF2MSl4iaExAAABl0lEQVR42oVT52KCMBAmhIQ9RKU4UCTu9nv/1+slmAY77P0gt7j5nTehzdk/Mnb0z4n3CzVVCCIhQMSq5ru9TiEqia4oTpB3hrR+MuccWVl8LN608Lb48MoM63wSfgWfYsY4aOmAmFQ+Vl9p5hL61wR8lDkSHQhy/nBYIwZvvKXRG8+l13AorEd5Bp8CpqVSNqRS9xR+5GNmCsyyiLwEsL0OOcnDdQsIskVZpgutUBq/DpoYM09nWihR0VeI4pGprPkqjle8LsfYXkE2U5EhH72toYdvXlP3DptR2OOr7wbtYzvYkT4aBZm6yaVyfCPsPSVsb6FzCG3HQnnbRRCEYRiESA2j+SAFKTS32GqH8C+HQDu4FMylYC7Fv0W6Nts/2kzQ/RjUwQ6qQ+JGXaO+3Fop2+WFWDvqybJOcESRH8ty62aAurz3+bx/nynir3bdBjDRDagmgIl3wKkgwFjIEbr6Z8gNLSTWL0F7JNC+gv3Nwn5yOIM9nEEfDs+fTy+DuEuqbN5BVu70psfLXh6vqX48f37eTJSf3RsxQgv5s/cAAAAASUVORK5CYII=') no-repeat 0 0;}
  `;
const navigationItems = Object.values(navigationItem)


const Navigation = () => {
  const options = [
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Portuguese', label: 'Portuguese' },
    { value: 'Chinese', label: '中文' },
    { value: 'Vietnamese', label: 'Vietnamese' }
  ];
  const { agentDetails,openTrans,setOpenTrans } = useContext(ChatContext)
  // console.log("agentDetails========================", agentDetails);


  const [transValue, setTransValue] = useState(getStoreItem(transKey));
  const [notifyStatus, setNotifyStatus] = useState(getStoreItem(notifyKey));
  const [transStatus, setTransStatus] = useState(getStoreItem(transStatusKey));

  setOpenTrans(transStatus && transStatus==='1')



  const handleTranChange = (item) => {
    setTransValue(item.value)
    setStoreItem(transKey, item.value);

  };
  const handleNotifyStatusChange = (item) => {
    const val = item.target.checked ? "1" : "0";
    setNotifyStatus(val)
    setStoreItem(notifyKey, val);

  };
  const handleTransStatusChange = (value) => {
    const val = value == "1" ? "0" : "1";
    setTransStatus(val)
    setStoreItem(transStatusKey, val);
    setOpenTrans(val==='1')

  };


  return (

    <TabsWrapper>
      <HeaderBox>
        <UserInfo>
          <UserImg>
            <img style={{}} src={agentDetails?.my_profile?.avatar || 'data:image/png;base64,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'} />
          </UserImg>
          <UserName>
            <p>{agentDetails?.my_profile?.email} </p>
            <p className="userAdmin">{agentDetails?.my_profile?.name || '超级管理员'}(24.4.2.001)</p>
          </UserName>
          <UserActive>
            <span className="userOnline"></span>
            {/* <span className="userUnline"></span> */}
          </UserActive>
          <UserInfoLine></UserInfoLine>
        </UserInfo>
        <HeaderControl>
          <ControlItem><span className="voice"></span>
            <Switch className="Hswitch" size="basic" on={notifyStatus == "1"} onClick={handleNotifyStatusChange} name="开启通知"></Switch>
          </ControlItem>

          {
            //   <ControlItem>
            //   <span className="robot"></span>
            //   <UserActive>
            //     {/* <span className="userOnline"></span> */}
            //     <span className="userUnline"></span>
            //   </UserActive>
            // </ControlItem>
          }

          <ControlItem style={{ position: 'relative' }}>
            <span className="fanyi"></span>
            <div className="fanyi-pop" >
              <Select className="SwitchBoxSelect"
                defaultValue={transValue}
                placeholder={transValue}
                onChange={handleTranChange}
                options={options}
              />
            </div>
            <UserActive>

              <span title="to translate" className={transStatus == "1" ? 'point userOnline' : 'point userUnline'} onClick={() => handleTransStatusChange(transStatus)}  ></span>
            </UserActive></ControlItem>
        </HeaderControl>
        {/* <LogoItem href="https://livechat.com/" target="_blank">
          <LiveChatLogo />
        </LogoItem> */}
      </HeaderBox>
      {/* <TabsList> */}
        {/* {navigationItems.map(item => (
          <TabItem
            key={item}
            onClick={() => setActiveTab(item)}
            isSelected={item === activeTab}
          >
            {item}
          </TabItem>
        ))} */}
      {/* </TabsList> */}
    </TabsWrapper>

  )
};

export default Navigation;
